"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster as Sonner } from "sonner";
export const Toaster = (_param)=>{
    var { type } = _param, props = _object_without_properties(_param, [
        "type"
    ]);
    if (type === "live") {
        return /*#__PURE__*/ _jsx(Sonner, _object_spread({
            theme: "dark",
            className: "toaster group",
            gap: 8,
            mobileOffset: {
                bottom: 45
            },
            toastOptions: {
                style: {
                    backgroundColor: "rgba(35, 39, 46, 0.7)",
                    backdropFilter: "blur(24px)",
                    color: "#FFFFFF",
                    borderRadius: "200px",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    boxShadow: "5px 5px 9px 0px rgba(0,0,0,0.24)"
                }
            }
        }, props));
    }
    return /*#__PURE__*/ _jsx(Sonner, _object_spread({
        theme: "dark",
        className: "toaster group",
        gap: 8,
        // offset={{ right: 425, top: 80 }} top right
        offset: {
            top: 70
        },
        mobileOffset: {
            top: 70
        },
        toastOptions: {
            style: {
                userSelect: "none",
                backdropFilter: "blur(24px)",
                backgroundColor: "rgba(35, 39, 46, 0.8)",
                color: "#FFFFFF",
                borderRadius: "14px",
                border: "1px solid rgba(255, 255, 255, 0.1)",
                boxShadow: "5px 5px 9px 0px rgba(0,0,0,0.24)"
            }
        }
    }, props));
};
